"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLinkNotarizationStatus = exports.SERVICE_LINK_SLOT_UNAVAILABLE = exports.SERVICE_LINK_APPROXIMATE_TIME_TO_LOCAL_TIME = exports.ServiceLinkApproximateTime = void 0;
var ServiceLinkApproximateTime;
(function (ServiceLinkApproximateTime) {
    ServiceLinkApproximateTime["morning"] = "morning";
    ServiceLinkApproximateTime["afternoon"] = "afternoon";
    ServiceLinkApproximateTime["evening"] = "evening";
})(ServiceLinkApproximateTime || (exports.ServiceLinkApproximateTime = ServiceLinkApproximateTime = {}));
// The local time booked with ServiceLink for each approximate window. ServiceLink business hours are 9 AM - 4 PM.
exports.SERVICE_LINK_APPROXIMATE_TIME_TO_LOCAL_TIME = {
    [ServiceLinkApproximateTime.morning]: '10:00', // 9 AM - 12 PM
    [ServiceLinkApproximateTime.afternoon]: '14:00', // 12 PM - 4 PM
    [ServiceLinkApproximateTime.evening]: '18:00', // After hours, not offered for Texas
};
// The requested time is not in ServiceLink's current availability, so the borrower picks another
exports.SERVICE_LINK_SLOT_UNAVAILABLE = 'SERVICE_LINK_SLOT_UNAVAILABLE';
var ServiceLinkNotarizationStatus;
(function (ServiceLinkNotarizationStatus) {
    ServiceLinkNotarizationStatus["CREATED"] = "CREATED";
    ServiceLinkNotarizationStatus["RESCHEDULE_PENDING"] = "RESCHEDULE_PENDING";
    ServiceLinkNotarizationStatus["SCHEDULE_REQUESTED"] = "SCHEDULE_REQUESTED";
    ServiceLinkNotarizationStatus["SCHEDULE_CONFIRMED"] = "SCHEDULE_CONFIRMED";
    ServiceLinkNotarizationStatus["CANCELLED"] = "CANCELLED";
    ServiceLinkNotarizationStatus["COMPLETED"] = "COMPLETED";
})(ServiceLinkNotarizationStatus || (exports.ServiceLinkNotarizationStatus = ServiceLinkNotarizationStatus = {}));
